module.exports = __webpack_public_path__ + "img/6_31.b36273d8.png";